import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import SourceForm from './SourceForm';
import BlitzAPI from '../../api/BlitzAPI';
import { handleFormErrors } from '../form/utils';

export default class SourceCreate extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(values) {
    return BlitzAPI.postSource({ source: values }).then(
      response => browserHistory.push('/sources'),
    ).catch(
      handleFormErrors,
    );
  }

  render() {
    return (
      <div>
        <h1>Create a new source</h1>
        <SourceForm onSubmit={this.handleSubmit} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/source/SourceCreate.js